import React from 'react';
import Input from '../../../shared/forms/Input';
import ProfilePasswordInput from './ProfilePasswordInput';

import { ReactComponent as PadlockIcon } from '../../../assets/icons/padlock.svg';
import { ReactComponent as EditIcon } from '../../../assets/icons/edit.svg';

const UserCard = ({user, setUser, editable = false, passwordEditable = false, onEditDetails, onDiscardDetails, onSaveDetails, onEditPassword, onDiscardPassword, onSavePassword}) => {
  let { fullName, telephone, companyName, email } = user;

  return (
    <div className="section-box--wide section-stack form">
      <div className="section-header__with-buttons">
        <h4 className="section-title">Primary user</h4>
        {!editable && (
          <button className="btn btn-subtle"
                  type="button"
                  onClick={onEditDetails}>
            <EditIcon className='icon sm' />
            Edit
          </button>
        )}
      </div>
      {!editable && (
        <div className="profile-fields">
          <Input label='Full Name'
                 value={fullName || '—'}
                 onChange={() => {}}
                 disabled={true} />
          <Input label='Company Name'
                 value={companyName || '—'}
                 onChange={() => {}}
                 disabled={true} />
          <div className="profile-field-stack">
            <Input label='E-mail'
                   value={email || '—'}
                   onChange={() => {}}
                   disabled={true}
                   icon={<PadlockIcon className='icon sm'
                   style={{
                            fill:' var(--surface-contrast-higher)',
                          }} />} />
            <p className="field-help">
              To change your email address, please contact <a href="mailto:team@polygraph.net">team@polygraph.net</a>
            </p>
          </div>
          <Input label='Telephone'
                 value={telephone || '—'}
                 onChange={() => {}}
                 disabled={true} />
        </div>
      )}

      {editable && (
        <div className="profile-fields">
          <Input label='Full Name'
                 value={fullName}
                 onChange={(e) => setUser({...user, fullName: e.target.value})} />
          <Input label='Company Name'
                 value={companyName}
                 onChange={(e) => setUser({...user, companyName: e.target.value})} />
          <div className="profile-field-stack">
            <Input label='E-mail'
                   value={email}
                   onChange={(e) => {}}
                   disabled={true}
                   icon={<PadlockIcon className='icon sm'
                   style={{
                            fill:' var(--surface-contrast-higher)',
                          }} />} />
            <p className="field-help">
              To change your email address, please contact <a href="mailto:team@polygraph.net">team@polygraph.net</a>
            </p>
          </div>
          <Input label='Telephone'
                 value={telephone}
                 onChange={(e) => setUser({...user, telephone: e.target.value})} />
        </div>
      )}
      {editable && (
        <div className="form-actions">
          <button className="btn secondary compact"
                  type="button"
                  onClick={onDiscardDetails}>
            Discard changes
          </button>
          <button className="btn primary compact"
                  type="button"
                  onClick={onSaveDetails}>
            Save changes
          </button>
        </div>
      )}

      <div className="profile-subsection">
        <div className="section-header__with-buttons">
          <h5 className="profile-subtitle">Password</h5>
          {!passwordEditable && (
            <button className="btn btn-subtle"
                    type="button"
                    onClick={onEditPassword}>
              <EditIcon className='icon sm' />
              Change password
            </button>
          )}
        </div>

        {!passwordEditable && (
          <div className="profile-display">
            <span className="profile-display-value">••••••••••</span>
          </div>
        )}

        {passwordEditable && (
          <div className="profile-fields">
            <div className="profile-field-stack">
              <ProfilePasswordInput label='New Password'
                              onChange={(e) => setUser({...user, password: e.target.value})}
                              value={user.password}
                              showWarning={true} />
              <p className="field-help">
                 8+ characters, with min one number and one uppercase character.
              </p>
            </div>
            <ProfilePasswordInput label='Confirm New Password'
                            target={user.password}
                            onChange={(e) => setUser({...user, password2: e.target.value})}
                            value={user.password2}
                            showWarning={true} />
          </div>
        )}
        {passwordEditable && (
          <div className="form-actions">
            <button className="btn secondary compact"
                    type="button"
                    onClick={onDiscardPassword}>
              Discard changes
            </button>
            <button className="btn primary compact"
                    type="button"
                    onClick={onSavePassword}>
              Save changes
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserCard;
